export default __webpack_public_path__ + "63f1c5b15db5e12cd1c7d724c38c862d.png";